<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <!-- Page Header -->
    <div class="page-title-wrapper">
        <!-- Summary Cards -->
        <ms-payment-history-summary-cards
            [summary]="summary()"
            [currency]="currency()"
            [isLoading]="isSummaryLoading()" />

        <div class="d-flex justify-content-between flex-row flex-wrap gap-3">

            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Payments"
                        aria-label="Search Payments"
                        [ngModel]="userSessionService.paymentHistoryFilter.searchTerm"
                        (ngModelChange)="userSessionService.paymentHistoryFilter.searchTerm = $event"
                        (keyup.enter)="onSearch()" aria-describedby="payment-search-description">

                    @if (userSessionService.paymentHistoryFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button"
                            (click)="onSearch()">
                            Search
                        </button>
                    </div>
                </div>
                <div id="payment-search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by invoice name, invoice #, or property
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-payment-history-search-filter
                    [filter]="userSessionService.paymentHistoryFilter"
                    (filterApplied)="onFilterApplied()" />

                <ms-sort-dropdown
                    [sortOptions]="sortOptions"
                    [selectedSortOption]="orderBy()"
                    (selectedSortOptionChange)="onSortChanged($event)" />

                <div class="dropdown" [msCloseMenuOnSettle]="isDownloading()">
                    <button class="btn btn-primary dropdown-toggle" type="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <span>List Actions</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isDownloading()"
                                [attr.aria-disabled]="isDownloading() ? 'true' : null"
                                [attr.tabindex]="isDownloading() ? -1 : null"
                                msDebounceClick
                                (msDebounceClick)="$event.stopPropagation(); downloadFilteredPayments()">
                                @if (isDownloading()) {
                                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
                                } @else {
                                    <fa-duotone-icon icon="file-csv" secondaryOpacity="0.9" class="me-2" />Download Filtered Payments
                                }
                            </a>
                        </li>
                        <li *ifHasPermission="{
                                requiredPermissions: [PaymentsPermission.Read],
                                userPermissionOnly: false
                            }">
                            <a class="dropdown-item"
                                [class.disabled]="!paymentList?.selectedCount() || paymentList?.isBulkResendingReceipts()"
                                (click)="paymentList?.resendSelectedReceipts()">
                                @if (paymentList?.isBulkResendingReceipts()) {
                                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
                                } @else {
                                    <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Resend Receipts
                                }
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Payment History List -->
    <ms-payment-history-list
        #paymentList
        class="d-block"
        [filter]="userSessionService.paymentHistoryFilter"
        [orderByInput]="orderBy()"
        [viewLocation]="PaymentHistoryListViewLocations.OrganizationPaymentsHistoryPage"
        (orderByChanged)="onListOrderByChanged($event)" />
</div>
